import React, { useRef, useEffect } from 'react';
import Fade from 'react-reveal/Fade';

function lerp(start, end, amt ){
    return (1 - amt) * start + amt * end;
}

export default function Goo() {
    const b1 = useRef(null);
    const b2 = useRef(null);
    const b3 = useRef(null);
    const main = useRef();

    let b1X = 0;
    let b1Y = 0;
    let b2X = 0;
    let b2Y = 0;
    let b3X = 0;
    let b3Y = 0;

    let mouseX = window.innerWidth / 2;
    let mouseY = window.innerHeight / 2;

    useEffect(() => {
        document.addEventListener('mousemove', mouseMoveEvent);
        return () => {
            document.removeEventListener('mousemove', mouseMoveEvent);
        }
    }, []);

    const mouseMoveEvent = e => {
        mouseX = e.clientX;
        mouseY = e.clientY;
    }

    function move() {
        try {
            let b1NX = lerp(b2X, mouseX, 0.5);
            let b1NY = lerp(b2Y, mouseY, 0.5);
            b1.current.style.transform = "translate(" + (b1NX - 85) + "px ," + (b1NY - 85) + "px)";
            b1X = b1NX;
            b1Y = b1NY;

            let b2NX = lerp(b2X, mouseX, 0.025);
            let b2NY = lerp(b2Y, mouseY, 0.025);
            b2.current.style.transform = "translate(" + (b2NX - 175) + "px ," + (b2NY - 175) + "px)";
            b2X = b2NX;
            b2Y = b2NY;

            let b3NX = lerp(b3X, mouseX, 0.01);
            let b3NY = lerp(b3Y, mouseY, 0.01);
            b3.current.style.transform = "translate(" + (b3NX - 100) + "px ," + (b3NY - 100) + "px)";
            b3X = b3NX;
            b3Y = b3NY;
        } catch {}
    }

    // useEffect(() => {
    //     document.addEventListener('scroll', scrollEvent);
    // }, []);
    // const scrollEvent = e => {
    //     let scroll = 1 - window.scrollY / (window.innerHeight / 1.5);
    //     scroll = Math.max(scroll, 0);
    //     scroll = Math.round(scroll * 100) / 100;
    //     main.current.style.opacity = "" + scroll;
    // }

    return setInterval(() => move(), 1000/60), (
        <div id="Goo">
            <svg style={{ position: 'absolute', width: 0, height: 0 }}>
                <filter id="goo">
                    <feGaussianBlur in="SourceGraphic" result="blur" stdDeviation="40" />
                    <feColorMatrix in="blur" values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 30 -7" />
                </filter>
            </svg>
            <div className="hooks-main" ref={main}>
                <div className="hooks-filter">
                    <div className="b1" ref={b1} style={{ }} />
                    <div className="b2" ref={b2} style={{ }} />
                    <div className="b3" ref={b3} style={{ }} />
                </div>
            </div>
        </div>
    )
}